import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, normalizeClass as _normalizeClass, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "me-2 fas fa-mobile-alt" }, null, -1 /* HOISTED */)
const _hoisted_3 = ["href"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "me-2 fas fa-mobile-alt" }, null, -1 /* HOISTED */)
const _hoisted_9 = ["href"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "text-default" }, "Not Available", -1 /* HOISTED */)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "text-default" }, "Not Available", -1 /* HOISTED */)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "text-default" }, "Not Available", -1 /* HOISTED */)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { class: "text-center" }
const _hoisted_25 = {
  key: 0,
  class: "big-text"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-comment-dots text-info" }, null, -1 /* HOISTED */)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = { key: 1 }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", { class: "text-default" }, "Not Available", -1 /* HOISTED */)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = { class: "text-end" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-edit icon-size" }, null, -1 /* HOISTED */)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn px-1 py-0 ms-1 btn-outline-primary icon-size",
  "data-bs-toggle": "dropdown",
  id: "InquiryRow__Actions${id}"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ellipsis-h icon-size" })
], -1 /* HOISTED */)
const _hoisted_35 = {
  class: "dropdown-menu",
  "aria-labelledby": "InquiryRow__Actions${id}"
}
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = {
  key: 0,
  colspan: "4"
}
const _hoisted_39 = {
  key: 0,
  class: "edit-row"
}
const _hoisted_40 = ["colspan"]
const _hoisted_41 = {
  key: 2,
  class: "text-center pt-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormatName = _resolveComponent("FormatName")!
  const _component_EmptyTextHandler = _resolveComponent("EmptyTextHandler")!
  const _component_TablePrompt = _resolveComponent("TablePrompt")!
  const _component_InquiryForm = _resolveComponent("InquiryForm")!
  const _component_InquiryFormHomecareHomehealth = _resolveComponent("InquiryFormHomecareHomehealth")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("tr", {
      id: "Inquiry_Row",
      class: _normalizeClass(`border-line ${_ctx.inquiry.id === _ctx.editInProgressId || _ctx.isDeleteRequested ? 'edit-row td-border' : ''} ${
            _ctx.newInquiryId === _ctx.inquiry.id ? 'table-info animated flash' : ''
        }`)
    }, [
      _createElementVNode("td", null, _toDisplayString(_ctx.formatDateFromDate(_ctx.inquiry.date)), 1 /* TEXT */),
      _createElementVNode("td", null, [
        _createVNode(_component_FormatName, {
          firstName: _ctx.inquiry.firstName,
          lastName: _ctx.inquiry.lastName
        }, null, 8 /* PROPS */, ["firstName", "lastName"]),
        _hoisted_1,
        _hoisted_2,
        _createElementVNode("a", {
          href: `tel:${_ctx.inquiry.phoneNumbers[0]?.number}`
        }, _toDisplayString(_ctx.formatPhone(_ctx.inquiry.phoneNumbers[0]?.number)), 9 /* TEXT, PROPS */, _hoisted_3)
      ]),
      _createElementVNode("td", null, [
        (_ctx.inquiry.contactFirstName)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
              (_ctx.inquiry.contactLastName)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.inquiry.contactLastName) + ",", 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              _createTextVNode(" " + _toDisplayString(_ctx.inquiry.contactFirstName), 1 /* TEXT */)
            ]))
          : _createCommentVNode("v-if", true),
        _hoisted_6,
        (_ctx.inquiry.contactPhoneNumbers[0]?.number)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("a", {
                href: `tel:${_ctx.inquiry.contactPhoneNumbers[0]?.number}`
              }, _toDisplayString(_ctx.formatPhone(_ctx.inquiry.contactPhoneNumbers[0]?.number)), 9 /* TEXT, PROPS */, _hoisted_9)
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, {
          text: _ctx.inquiry.branchName
        }, null, 8 /* PROPS */, ["text"])
      ]),
      _createElementVNode("td", null, [
        (_ctx.inquiry.servicesRequested?.length > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.getLineOfService([..._ctx.inquiry.servicesRequested])), 1 /* TEXT */))
          : (_openBlock(), _createElementBlock("span", _hoisted_11, [
              (_ctx.inquiryApplication)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.inquiryApplication), 1 /* TEXT */))
                : (_openBlock(), _createElementBlock("small", _hoisted_13, _hoisted_15))
            ]))
      ]),
      _createElementVNode("td", null, [
        (_ctx.inquiry.assignedUser?.length > 2)
          ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.inquiry.assignedUser), 1 /* TEXT */))
          : (_openBlock(), _createElementBlock("small", _hoisted_17, _hoisted_19))
      ]),
      _createElementVNode("td", null, [
        (_ctx.inquiry.followUpDate)
          ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.formatDateFromDate(_ctx.inquiry.followUpDate)), 1 /* TEXT */))
          : (_openBlock(), _createElementBlock("small", _hoisted_21, _hoisted_23))
      ]),
      _createElementVNode("td", _hoisted_24, [
        (_ctx.inquiry.comment?.length > 0)
          ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_27)), [
              [_directive_tooltip, { title: _ctx.inquiry.comment }]
            ])
          : (_openBlock(), _createElementBlock("span", _hoisted_28, _hoisted_30))
      ]),
      _withDirectives(_createElementVNode("td", _hoisted_31, [
        _withDirectives((_openBlock(), _createElementBlock("button", {
          type: "button",
          class: "btn table-btn px-2 btn-outline-info",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openEditInquiry(_ctx.inquiry.application)))
        }, _hoisted_33)), [
          [_vShow, _ctx.hasEditPermission && !_ctx.editInProgressId],
          [_directive_tooltip, { title: _ctx.actionButtonTooltipEnum.Edit }]
        ]),
        _hoisted_34,
        _createElementVNode("div", _hoisted_35, [
          (_ctx.isConvertAllowed)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: "dropdown-item",
                href: "javascript:void(0);",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.navigateToReferralPage()))
              }, " Convert to Referral "))
            : _createCommentVNode("v-if", true),
          (_ctx.inquiry.id !== _ctx.editInProgressId && _ctx.inquiry.canDelete)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                class: "dropdown-item",
                href: "javascript:void(0);",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.confirmDeleteInquiry()))
              }, " Delete "))
            : _createCommentVNode("v-if", true)
        ]),
        (_ctx.inquiry.id == _ctx.editInProgressId)
          ? (_openBlock(), _createElementBlock("i", _hoisted_36, "Edit In Progress"))
          : _createCommentVNode("v-if", true),
        (!_ctx.inquiry.canDelete && !_ctx.inquiry.canEdit)
          ? (_openBlock(), _createElementBlock("i", _hoisted_37, "No Actions"))
          : _createCommentVNode("v-if", true)
      ], 512 /* NEED_PATCH */), [
        [_vShow, !_ctx.isDeleteRequested]
      ]),
      _createCommentVNode(" DELETE "),
      (_ctx.isDeleteRequested)
        ? (_openBlock(), _createElementBlock("td", _hoisted_38, [
            _createVNode(_component_TablePrompt, {
              "ok-text": "Delete",
              cancelText: "Cancel",
              name: "Inquiry",
              message: "Do you want to delete this inquiry?",
              includeYes: false,
              isInProgress: _ctx.isDeleteInProgress,
              ok: _ctx.deleteInquiry,
              cancel: _ctx.cancelDeleteInquiry
            }, null, 8 /* PROPS */, ["isInProgress", "ok", "cancel"])
          ]))
        : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */),
    _createCommentVNode(" EDIT "),
    (_ctx.isEditRequested)
      ? (_openBlock(), _createElementBlock("tr", _hoisted_39, [
          _createElementVNode("td", {
            colspan: _ctx.columns,
            class: "p-3 edit"
          }, [
            (_ctx.isApplicationHospice || _ctx.isApplicationPalliative)
              ? (_openBlock(), _createBlock(_component_InquiryForm, {
                  key: 0,
                  inquiry: _ctx.cachedData,
                  isLoading: _ctx.isEditSaveInProgress,
                  serviceTypeEnums: _ctx.serviceTypeEnums,
                  branches: _ctx.branches,
                  onUpdateBranch: _ctx.updateEditBranch
                }, null, 8 /* PROPS */, ["inquiry", "isLoading", "serviceTypeEnums", "branches", "onUpdateBranch"]))
              : _createCommentVNode("v-if", true),
            (_ctx.isApplicationHomeCare || _ctx.isApplicationHomehealth)
              ? (_openBlock(), _createBlock(_component_InquiryFormHomecareHomehealth, {
                  key: 1,
                  inquiry: _ctx.cachedData,
                  isLoading: _ctx.isEditSaveInProgress,
                  branches: _ctx.branches,
                  onUpdateBranch: _ctx.updateEditBranch,
                  isEdit: true
                }, null, 8 /* PROPS */, ["inquiry", "isLoading", "branches", "onUpdateBranch"]))
              : _createCommentVNode("v-if", true),
            (!_ctx.isEditSaveInProgress)
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary btn-md",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateInquiry()))
                  }, "Save Inquiry"),
                  (_ctx.isApplicationHospice || _ctx.isApplicationPalliative)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-success btn-md ms-2",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleConvertToReferral()))
                      }, " Convert To Referral "))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-secondary btn-md ms-2",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.closeEditInquiry()))
                  }, " Cancel ")
                ]))
              : _createCommentVNode("v-if", true)
          ], 8 /* PROPS */, _hoisted_40)
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}